import React from "react";

const Textarea = ({ label, helper, error, className = "", ...props }) => {
  return (
    <label className="flex flex-col gap-2 text-sm text-slate-600">
      {label}
      <textarea
        className={[
          "min-h-[96px] rounded-lg border px-4 py-3 text-base text-slate-900 shadow-sm",
          "outline-none transition",
          error ? "border-rose-300 focus:border-rose-400" : "border-slate-200 focus:border-slate-400",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        {...props}
      />
      {helper && !error && <span className="text-xs text-slate-500">{helper}</span>}
      {error && <span className="text-xs text-rose-600">{error}</span>}
    </label>
  );
};

export default Textarea;
